import React from 'react'
import TopBar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Breadcrumb from '../../Globle/Breadecrumb'
import Contact from '../Maincontactus/Contact'
import Form from '../Maincontactus/Form'
import Footer1 from '../../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadcrumb title='Contactus' />
            <Contact />
            <Form />
            <Footer1 />
        </>
    )
}

export default Main
